import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useLocation } from 'react-router-dom';

import { PerformanceMark } from 'ui-components/components/performance-mark';
import { PerformanceMeasure } from 'ui-components/components/performance-measure';
import { PerformanceService } from 'ui-components/services/performance-service';

import { useSelectedOrdersViewId } from './orders-left-nav/orders-left-nav-context';
import { OrdersPage } from './orders-page';
import { useQuery } from '../../hooks/routing/use-query';
import { useOnComponentMount } from '../../hooks/use-on-component-mount';
import { usePrevious } from '../../hooks/use-previous';
import { getLocationQuickSearchTerm } from '../../services/quicksearch-location-service';
import { prepareToOpenNewOrderModal } from '../../store/orders/edit-order/edit.order.actions';
import * as NavActions from '../../store/orders/nav/orders.nav.actions';

const endMarkComparator = () => {
  return !!document.querySelector('[class^="grid-without-banner"]');
};

const OrdersPageLoader = () => {
  const location = useLocation();
  const propStatusViewId = useSelectedOrdersViewId();
  const { statusViewId } = useParams();
  const view = statusViewId || propStatusViewId;
  const dispatch = useDispatch();
  const previousLocation = usePrevious(location);
  const query = useQuery();

  useOnComponentMount(() => {
    const searchTerm = getLocationQuickSearchTerm(location);
    if (!searchTerm) {
      return;
    }
    dispatch(NavActions.ordersSearchTermCount({ searchTerm }));
    dispatch(NavActions.changeViewSearch({ searchTerm }));
  });

  useEffect(() => {
    const previousPropsHadSearchTerm = getLocationQuickSearchTerm(previousLocation);
    const newPropsHaveSearchTerm = getLocationQuickSearchTerm(location);
    const userNavigationShouldClearSearch = previousPropsHadSearchTerm && !newPropsHaveSearchTerm;
    if (userNavigationShouldClearSearch) {
      dispatch(NavActions.clearSearchInput());
    }
  }, [dispatch, location, previousLocation, view]);

  useEffect(() => {
    if (query.get('openNewOrderModal') === 'true') {
      dispatch(prepareToOpenNewOrderModal());
      const newUrl = new URL(window.location);
      newUrl.searchParams.delete('openNewOrderModal');
      window.history.replaceState({}, '', newUrl.pathname + newUrl.search);
    }
  }, [dispatch, query]);

  return (
    <>
      <PerformanceMark comparator={endMarkComparator} name={`orders-${view}-page-end`} pollTimer={50}>
        {(endMark) => {
          const pageStartMark = PerformanceService.getMark('page-load-start[0]');

          if (!pageStartMark || !endMark) {
            return null;
          }

          return <PerformanceMeasure end={endMark} name={`orders-${view}-page`} start={pageStartMark} />;
        }}
      </PerformanceMark>
      <OrdersPage />
    </>
  );
};

export { OrdersPageLoader };
